import React from 'react';
import { useRouter } from '@framework/router';
import { UTC_TIME_ZONE } from '@framework/timezone/constants';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import FooterContainer from './TraceSidebarFooterContainer';
import TagsContainer from './TraceSidebarTagsContainer';
import { filtersKeys } from './constants';
import DatePeriodContainer from './Sections/DatePeriodContainer';
import SectionsContainer from './Sections/SectionsContainer';
import createFiltersStore from '@framework/ui/Organisms/Filters/createFiltersStore';
import FinsightSidebar from '@/creditflowresearch/ui/common/components/FinsightSidebar/FinsightSidebar';
import { useFiltersContext as useFilters } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useCheckboxerContext } from '@framework/ui/Organisms/Filters/Checkboxer/CheckboxerContext';
import { useTraceAssetClassesContext } from '@/creditflowresearch/application/Trace/TraceAssetClassesContext';

const TraceSidebar = (props) => {
  const {
    dateFromMin,
    isFetching,
    appliedFilters,
    applyFilter,
    fetchFilter,
    resetFilters,
  } = useTraceFiltersContext();
  const { handlePageChange } = useFiltersContext();
  const { currentAssetClass } = useTraceAssetClassesContext();
  const { filtersUpdate, getFilters } = useFilters();
  const { checkboxes } = useCheckboxerContext();
  const router = useRouter();

  const filters = getFilters(TRACE_STORE_NAME);

  const onFetchFilter = async () => {
    handlePageChange(1);
    fetchFilter(currentAssetClass.id, filters, checkboxes, router);
  };

  const onApplyFilter = async () => {
    handlePageChange(1);
    applyFilter(filters, checkboxes, router);
    fetchFilter(currentAssetClass.id, filters, checkboxes, router);
  };

  const onResetFilters = async () => {
    handlePageChange(1);
    resetFilters(currentAssetClass.id, filtersUpdate, checkboxes, router);
  };

  return (
    <FinsightSidebar
      { ...props }
      FooterContainer={ FooterContainer }
      TagsContainer={ TagsContainer }
      filtersKeys={ filtersKeys }
      dateFromMin={ dateFromMin }
      SectionsContainer={ SectionsContainer }
      isFetching={ isFetching }
      appliedFilters={ appliedFilters }
      filters={ filters }
      dateBoundsZone={ UTC_TIME_ZONE }
      DatePeriodContainer={ DatePeriodContainer }
      onFilterApply={ onApplyFilter }
      fetchFilter={ onFetchFilter }
      resetFilters={ onResetFilters }
    />
  );
};

export default createFiltersStore({ filterName: TRACE_STORE_NAME })(TraceSidebar);
